module.exports = __webpack_public_path__ + "img/carrom.99c68a59.jpg";